import { createSelector } from 'reselect'

import { buildPartnerDocumentSections } from '../../lib/documentsAndLinks'

import { selectCockpitEltDocuments } from './selectCockpitEltDocuments'
import { selectCockpitPartnerData } from './selectCockpitPartnerData'
import { selectCockpitQbrDocuments } from './selectCockpitQbrDocuments'

/** The one selector the "Documents and links" tile consumes for its per-partner sections.
 *
 *  Deliberately has NO fallback to the legacy `selectPartnerId` baked in: that's a global
 *  selector that can retain a stale, previously-viewed partner id in manager/multi-partner
 *  context, and folding it in here could manufacture a bogus single-partner section inside the
 *  manager view if `PartnerData` is briefly empty during load. The single-partner fallback
 *  (falling back to the *current* cockpit's own `partnerId` when `PartnerData` hasn't loaded
 *  yet) lives in `useCockpitDocumentsData` instead, which only applies it when explicitly asked
 *  to (single-partner mode). */
export const selectCockpitDocumentPartnerSections = createSelector(
  [selectCockpitPartnerData, selectCockpitEltDocuments, selectCockpitQbrDocuments],
  (partnerData, eltGroups, qbrGroups) =>
    buildPartnerDocumentSections(partnerData, eltGroups, qbrGroups)
)
